import { render, staticRenderFns } from "./newFileView.vue?vue&type=template&id=40eec708&scoped=true&"
import script from "./newFileView.vue?vue&type=script&lang=js&"
export * from "./newFileView.vue?vue&type=script&lang=js&"
import style0 from "./newFileView.vue?vue&type=style&index=0&id=40eec708&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40eec708",
  null
  
)

export default component.exports